import { connect } from 'react-redux';
import View from './RetirementAgesView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  RETIREMENT_AGES_WHAT_IF_KEY,
  RETIREMENT_AGES_WHAT_IF_PATH,
} from './RetirementAgesConstants';
import {
  principalName,
  partnerName,
  hasPartner,
  principalOptions,
  partnerOptions,
  principalAge,
  partnerAge,
  principalIsRetiredSelector,
  partnerIsRetiredSelector,
} from './RetirementAgesSelector';
import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  planImpact,
  initialPlanImpact,
} from '../../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  isOPLMonteCarloSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  principalName: principalName(state, ownProps),
  partnerName: partnerName(state, ownProps),
  hasPartner: hasPartner(state, ownProps),
  principalOptions: principalOptions(state, ownProps),
  partnerOptions: partnerOptions(state, ownProps),
  principalAge: principalAge(state, ownProps),
  partnerAge: partnerAge(state, ownProps),
  principalIsRetired: principalIsRetiredSelector(state, ownProps),
  partnerIsRetired: partnerIsRetiredSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
});

const mapDispatchToProps = dispatch => ({
  storeData: goalId => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, RETIREMENT_AGES_WHAT_IF_KEY, data));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RETIREMENT_AGES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        RETIREMENT_AGES_WHAT_IF_KEY,
      ),
    );
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RETIREMENT_AGES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        RETIREMENT_AGES_WHAT_IF_KEY,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId) => {
    dispatch(
      fetchWhatIfOptions(
        clientId,
        fpId,
        goalId,
        RETIREMENT_AGES_WHAT_IF_PATH,
        RETIREMENT_AGES_WHAT_IF_KEY,
      ),
    );
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        RETIREMENT_AGES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        RETIREMENT_AGES_WHAT_IF_KEY,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
